const navButton = document.querySelector<HTMLElement>(".nav-button");
const header = document.querySelector("#Header");
const menu = document.getElementById(navButton.getAttribute("aria-controls"));
const headerLogo = document.querySelector<HTMLElement>(".header-logo");
const mobileSearchButton: HTMLButtonElement = document.querySelector(".nav-mobile .search-button");
const headerHeight = 110;

// on window load we also want the collapsed header if we are further down the page
if (header && window.scrollY >= headerHeight) {
    header.classList.toggle("collapsed", window.scrollY >= headerHeight);
}

navButton.addEventListener("click", () => {
    const open = navButton.classList.toggle("open");
    menu.classList.toggle("open", open);
    headerLogo.classList.toggle("open", open);
    navButton.blur();
});

/* Hide mobile nav on search button click */
mobileSearchButton.addEventListener("click", () => {
    navButton.classList.remove("open");
    menu.classList.remove("open");
    headerLogo.classList.remove("open");
});

window.addEventListener("scroll", () => {
    header.classList.toggle("collapsed", window.scrollY >= headerHeight);
});
